export default function WriteInquiryPage() {
  return <div>WriteInquiryPage</div>;
}
